import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { disconnectService } from "../api/apps";
import { useAuth } from "../contexts/AuthContext";

export const useDisconnectApp = (integrationName) => {
  const { setApiUser } = useAuth();

  const { mutate: disconnect, isLoading: isDisconnecting } = useMutation({
    mutationFn: () => disconnectService(integrationName),
    onSuccess: (res) => {
      setApiUser(res.data.data);
      toast("Successfully disconnected", { type: "success" });
    },
    onError: () => {
      toast("Failed to disconnect", { type: "error" });
    },
  });

  return { disconnect, isDisconnecting };
};
